import { Trans } from '@lingui/react/macro';

import Box from '@/design_system/Box';
import FoldableSection from '@/design_system/FoldableSection';
import Stack from '@/design_system/Stack';
import Title from '@/design_system/Typography/Title';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';

import { ArticleAuthenticityCertificate } from './components/ArticleInfo/ArticleAuthenticityCertificate';
import { ProofOfAuthenticity } from './ProofOfAuthenticity';
import { PurchaseDate } from './PurchaseDate';
import { PurchaseLocation } from './PurchaseLocation';

export const AuthenticityForm = () => {
  const { article, view, errors } = useArticleContext();

  if (!(view.warranty.shown && view.warranty.type === 'authenticity' && view.warranty.editable)) {
    return null;
  }

  return (
    <FoldableSection
      label={
        <Title as="h2">
          <Trans id="requests.new.articles.drawer.authenticity.title">Authenticity</Trans>
        </Title>
      }
      isInvalid={errors.warranty?.hasError}
    >
      <Box padding="1rem" gap="1rem" className="bg-neutral-0">
        <Stack gap="1rem">
          {!!article.uniqueArticle && view.warranty.fields.authenticityCertificate.shown && (
            <ArticleAuthenticityCertificate mode="form" />
          )}
          {view.warranty.fields.purchaseDate.shown && <PurchaseDate />}
          {view.warranty.fields.purchaseLocation.shown && <PurchaseLocation />}
          {view.warranty.fields.proofOfAuthenticity.shown && <ProofOfAuthenticity />}
        </Stack>
      </Box>
    </FoldableSection>
  );
};
